

// API Functions
export const getHeaders = (csrfToken, apiHeader, apiKey) => { 
	let header = new Headers({
		'Content-Type': 'application/json',
		'X-CSRFToken': csrfToken,
		'Auth': apiHeader,
		'api-key': apiKey,
	});
	return header;
}

export const getHeaders2 = (csrfToken, apiHeader, apiKey) => { 
	let header = new Headers({
		'X-CSRFToken': csrfToken,
		'Auth': apiHeader,
		'api-key': apiKey,
	});
	return header;
}

export const getSortFields = () => ([
    { label: 'Project Name ↑', value: 'project_name' },
    { label: 'Finish Date ↑', value: 'substantial_completion_date' },
    { label: 'Profit Margin Change ↑', value: 'profit_margin' },
    { label: 'Profit Margin Change ↓', value: '-profit_margin' },
    // { label: 'Project Number ↑', value: 'project_number' },
    { label: 'Projected Contract Change ↑', value: 'contract_amount' },
    { label: 'Projected Contract Change ↓', value: '-contract_amount' },
])

export const getRequiredRoles = () => ([
	"Project Manager",
	"Superintendent",
	"Project Coordinator",
	"Project Executive",
	"General Superintendent",
	"Project Accountant",
])

export const toastStyle = () => ({
    duration: 5000,
    position: 'top-right',
    className: 'titillium-web',
})